/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { ImageHelper, RouteHelper } from "@nf/common";
import dynamic from "next/dynamic";

import AppImage from "components/AppImage";
import LinkWithLocale from "components/LinkWithLocale";
import MoreInfoButton from "components/MoreInfoButton";
import { useSyncCompleted } from "hooks";

import type { IListComponentItemProps } from "../../models";

import styles from "./ListComponentItemPromo.module.scss";

const MediaAdditionalInfo = dynamic(
  () => import("components/Media/MediaAdditionalInfo")
);

const PlayButton = dynamic(() => import("components/PlayButton"));

const MyListButton = dynamic(() => import("components/MyListButton"));

export const ListComponentItemPromo = ({ media }: IListComponentItemProps) => {
  const isAuthProcessCompleted = useSyncCompleted();

  if (!media) {
    return null;
  }

  return (
    <div className={styles.item}>
      <LinkWithLocale href={RouteHelper.goToDetails(media)}>
        <a className={styles.imageLink}>
          <div className={styles.imageContainer}>
            <AppImage
              src={
                ImageHelper.getHighlightAssetFrontpagelUrl(media.Images) || ""
              }
              alt={media.Title || ""}
              className={styles.image}
            />
          </div>
        </a>
      </LinkWithLocale>

      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.header}>{media.Description}</h1>

          <h2 className={styles.title}>{media.Title}</h2>

          <MediaAdditionalInfo
            type={media.MediaTypeCode}
            year={media.Year}
            categories={media.Categories}
            className={styles.metadata}
          />

          <p className={styles.description}>
            {media?.ShortDescription || media?.LongDescription || ""}
          </p>

          {isAuthProcessCompleted && (
            <div className={styles.actions}>
              <PlayButton media={media} />

              <MoreInfoButton media={media} />

              <MyListButton media={media} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
